import React from 'react';
import PropTypes from 'prop-types';

class SubmenuControl extends React.Component {
    render() {
        const { type } = this.props;
        const classes = ['submenu__control'];

        if (type) {
            classes.push(`submenu__control--${type}`);
        }

        return (
            <div className={classes.join(' ')} onClick={this.props.onClick}>
                {this.props.children}
            </div>
        );
    }
}

SubmenuControl.propTypes = {
    onClick: PropTypes.func,
    children: PropTypes.node,
    type: PropTypes.string,
};

SubmenuControl.defaultProps = {
    onClick: undefined,
    children: null,
    type: null,
};

export default SubmenuControl;
